import { useEffect, useRef } from "react";

import { usePunditUserContext } from "@/react/contexts/punditUserContext";
import { isDevelopmentEnv, isProductionEnv } from "@/react/helpers/envHelpers";
import { useCircleV4 } from "@/react/hooks/useCircleV4";
import { useCircleV4OptIn } from "@/react/hooks/useCircleV4OptIn";

import { useEclipseReadyModal } from ".";
import {
  clearEclipseReadyModalDismissal,
  wasEclipseReadyModalDismissedThisWeek,
} from "./dismissal";

export const useRenderEclipseReadyModal = () => {
  const { currentCommunity } = usePunditUserContext();
  const { isCircleV4, isCircleV4PreviewEnabled } = useCircleV4();
  const { shouldShowOptInBar } = useCircleV4OptIn();
  const modal = useEclipseReadyModal();
  const shownForCommunityIdRef = useRef<number | string | undefined>(undefined);

  useEffect(() => {
    const communityId = currentCommunity?.id;

    if (isCircleV4PreviewEnabled && communityId) {
      clearEclipseReadyModalDismissal(communityId);
      return;
    }

    if (
      (!isProductionEnv() && !isDevelopmentEnv()) ||
      isCircleV4 ||
      !shouldShowOptInBar ||
      !communityId ||
      wasEclipseReadyModalDismissedThisWeek(communityId) ||
      shownForCommunityIdRef.current === communityId
    ) {
      return;
    }

    shownForCommunityIdRef.current = communityId;
    void modal.show();
  }, [
    currentCommunity?.id,
    isCircleV4,
    isCircleV4PreviewEnabled,
    modal,
    shouldShowOptInBar,
  ]);
};
